import { Controller } from '@hotwired/stimulus';

/*
  Permite cerrar una ventana que se abrío previamente usando el componente NewTabButton
*/
export default class extends Controller {
  connect() {
    this.element.addEventListener('click', () => {
      window.close();
    });
  }
}
